import React from "react";
import { useReactAppState } from "../../containers/utils";
import { getClubsDir } from "../../utils";

const ClubName = ({ slug, name, abbreviation, isAbbreviationOnly }) => {
  const { isLeague, urlList } = useReactAppState();
  const { baseUrl } = urlList || {};

  return (
    (isAbbreviationOnly) ?
      <a href={`${baseUrl}/${getClubsDir()}/${slug}`} title={abbreviation} className="mls-o-table__club-link">
        <span className="mls-o-table__abbr">{abbreviation}</span>
      </a>
      :
      isLeague ?
        <a href={`${baseUrl}/${getClubsDir()}/${slug}`} title={name} className="mls-o-table__club-link">
          <span className="mls-o-table__name">{name}</span>
          <span className="mls-o-table__abbreviation">{abbreviation}</span>
        </a>
        :
        <>
          <span className="mls-o-table__name">{name}</span>
          <span className="mls-o-table__abbreviation">{abbreviation}</span>
        </>
  );
};

export default ClubName;
